import React from 'react';
import TranscribeBatchContainer from '../components/transcribeBatch.container';
import {useParams} from 'react-router-dom';
import {useAppSelector} from '../store/hooks';
import {projectDataSelector} from '../store/selectors/projects.selectors';

const BatchTranscribePage: React.FC = () => {
  const {projectId} = useParams<{ projectId?: string }>();
  const projects = useAppSelector(projectDataSelector);
  const project = projectId ? projects.find(p => p.id === projectId) : null;

  return (
    <div className="h-full bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900 overflow-auto">
      <div className="max-w-4xl mx-auto px-4 py-6">
        <div className="bg-gray-800 rounded-lg shadow-2xl p-5 mb-4 border border-gray-700">
          <div className="mb-4">
            <h1 className="text-2xl font-bold text-white mb-1">
              {project ? `${project.name} - Batch Transcribe` : 'Batch Transcribe Audio'}
            </h1>
            <p className="text-gray-400 text-sm">
                            Add multiple audio files to the transcription queue. Files will be processed sequentially in the background.
            </p>
          </div>

          <TranscribeBatchContainer projectId={projectId} project={project} />
        </div>
      </div>
    </div>
  );
}

export default BatchTranscribePage;
